
  import { Vue, Component, Prop } from "vue-property-decorator";

  import CardInfoChip from "@/components/card/CardInfoChip.vue";
  import ContractorManagerInformationProvider from "@/components/contractors/ContractorManagerInformationProvider.vue";
  import RemoveManagerContractorRequest from "@/components/contractors/RemoveManagerContractorRequest.vue";
  import AddContractorToCompany from "@/components/contractors/AddContractorToCompany.vue";

  import { Company, User } from "@/interface";

  @Component({
    components: {
      CardInfoChip,
      ContractorManagerInformationProvider,
      RemoveManagerContractorRequest,
      AddContractorToCompany,
    },
  })
  export default class ManagerContractorRequest extends Vue {
    @Prop({ type: Object, required: true }) readonly company!: Company;
    @Prop({ type: Object, required: true }) readonly user!: User;
    @Prop({ type: Object, required: true }) readonly currentUser!: User;
    @Prop({ type: Boolean, required: false, default: true }) readonly showText!: boolean;
    @Prop({ type: String, required: false, default: 'linkButton' }) readonly variant!: string;
  }
